/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-sql-window-functions-visualizer-fr block)");
/* eslint-enable no-console */
(function () {
    const data = [
        { nom: "Alice", dept: "Tech", salaire: 4200, mois: 1 },
        { nom: "Bob", dept: "Tech", salaire: 5100, mois: 2 },
        { nom: "Claire", dept: "Tech", salaire: 5100, mois: 3 },
        { nom: "David", dept: "Marketing", salaire: 3800, mois: 1 },
        { nom: "Emma", dept: "Marketing", salaire: 4500, mois: 2 },
        { nom: "Frank", dept: "Marketing", salaire: 3800, mois: 3 },
        { nom: "Grace", dept: "RH", salaire: 3200, mois: 1 },
        { nom: "Hugo", dept: "RH", salaire: 3600, mois: 2 }
    ];

    const configs = {
        "ROW_NUMBER": {
            cols: ["nom", "dept", "salaire", "row_number"],
            headers: ["nom", "dept", "salaire", "ROW_NUMBER()"],
            compute: function () {
                const partitions = {};
                return data.map(function (r) {
                    if (!partitions[r.dept]) partitions[r.dept] = 0;
                    partitions[r.dept]++;
                    return { nom: r.nom, dept: r.dept, salaire: r.salaire, computed: partitions[r.dept], isNull: false };
                });
            },
            sql: "SELECT nom, dept, salaire,\n  ROW_NUMBER() OVER (PARTITION BY dept ORDER BY salaire DESC) AS row_num\nFROM employes;",
            explication: "<strong>ROW_NUMBER()</strong> attribue un num&#233;ro unique et s&#233;quentiel &#224; chaque ligne au sein de sa partition. M&#234;me si deux lignes ont le m&#234;me salaire, elles re&#231;oivent des num&#233;ros diff&#233;rents. Utile pour r&#233;cup&#233;rer la <em>n-i&#232;me ligne</em> d&apos;un groupe (ex&#160;: l&apos;employ&#233; le mieux pay&#233; par d&#233;partement)."
        },
        "RANK": {
            cols: ["nom", "dept", "salaire", "rank"],
            headers: ["nom", "dept", "salaire", "RANK()"],
            compute: function () {
                const depts = {};
                data.forEach(function (r) {
                    if (!depts[r.dept]) depts[r.dept] = [];
                    depts[r.dept].push(r.salaire);
                });
                Object.keys(depts).forEach(function (d) { depts[d].sort(function (a, b) { return b - a; }); });
                const partCount = {};
                return data.map(function (r) {
                    if (!partCount[r.dept]) partCount[r.dept] = {};
                    const sorted = depts[r.dept];
                    const rank = sorted.indexOf(r.salaire) + 1;
                    return { nom: r.nom, dept: r.dept, salaire: r.salaire, computed: rank, isNull: false };
                });
            },
            sql: "SELECT nom, dept, salaire,\n  RANK() OVER (PARTITION BY dept ORDER BY salaire DESC) AS rang\nFROM employes;",
            explication: "<strong>RANK()</strong> attribue le m&#234;me rang aux lignes ex-&#230;quo, puis <strong>saute les rangs suivants</strong>. Exemple&#160;: deux employ&#233;s &#224; 5100 re&#231;oivent le rang 1, le suivant re&#231;oit le rang 3 (pas 2). Penser au classement sportif&#160;: deux m&#233;daill&#233;s d&apos;or, personne en argent."
        },
        "DENSE_RANK": {
            cols: ["nom", "dept", "salaire", "dense_rank"],
            headers: ["nom", "dept", "salaire", "DENSE_RANK()"],
            compute: function () {
                const depts = {};
                data.forEach(function (r) {
                    if (!depts[r.dept]) depts[r.dept] = [];
                    if (depts[r.dept].indexOf(r.salaire) === -1) depts[r.dept].push(r.salaire);
                });
                Object.keys(depts).forEach(function (d) { depts[d].sort(function (a, b) { return b - a; }); });
                return data.map(function (r) {
                    const rank = depts[r.dept].indexOf(r.salaire) + 1;
                    return { nom: r.nom, dept: r.dept, salaire: r.salaire, computed: rank, isNull: false };
                });
            },
            sql: "SELECT nom, dept, salaire,\n  DENSE_RANK() OVER (PARTITION BY dept ORDER BY salaire DESC) AS rang\nFROM employes;",
            explication: "<strong>DENSE_RANK()</strong> fonctionne comme RANK() mais <strong>sans saut de rang</strong>. Deux ex-&#230;quo au rang 1, le suivant est au rang 2 (et non 3). Pr&#233;f&#233;r&#233; quand on veut une num&#233;rotation continue sans trous."
        },
        "NTILE": {
            cols: ["nom", "dept", "salaire", "ntile"],
            headers: ["nom", "dept", "salaire", "NTILE(n)"],
            compute: function () {
                const n = parseInt(document.getElementById("ntileN").value, 10) || 3;
                const sorted = data.slice().sort(function (a, b) { return b.salaire - a.salaire; });
                const size = Math.ceil(sorted.length / n);
                return sorted.map(function (r, i) {
                    return { nom: r.nom, dept: r.dept, salaire: r.salaire, computed: Math.floor(i / size) + 1, isNull: false };
                });
            },
            sql: "SELECT nom, dept, salaire,\n  NTILE(3) OVER (ORDER BY salaire DESC) AS groupe\nFROM employes;",
            explication: "<strong>NTILE(n)</strong> divise les lignes en <em>n</em> groupes de taille &#233;gale (ou presque), num&#233;rot&#233;s de 1 &#224; n. Tr&#232;s utile pour cr&#233;er des quartiles (n=4), d&#233;ciles (n=10) ou toute segmentation par tranches &#233;gales."
        },
        "SUM_PART": {
            cols: ["nom", "dept", "salaire", "sum_dept"],
            headers: ["nom", "dept", "salaire", "SUM() par d&#233;pt"],
            compute: function () {
                const sums = {};
                data.forEach(function (r) {
                    sums[r.dept] = (sums[r.dept] || 0) + r.salaire;
                });
                return data.map(function (r) {
                    return { nom: r.nom, dept: r.dept, salaire: r.salaire, computed: sums[r.dept], isNull: false };
                });
            },
            sql: "SELECT nom, dept, salaire,\n  SUM(salaire) OVER (PARTITION BY dept) AS total_dept\nFROM employes;",
            explication: "<strong>SUM() OVER(PARTITION BY dept)</strong> calcule la somme des salaires de chaque d&#233;partement et l&apos;affiche sur <em>chaque ligne</em> du d&#233;partement. Contrairement &#224; GROUP BY, les lignes individuelles sont conserv&#233;es."
        },
        "AVG_PART": {
            cols: ["nom", "dept", "salaire", "avg_dept"],
            headers: ["nom", "dept", "salaire", "AVG() par d&#233;pt"],
            compute: function () {
                const sums = {}, counts = {};
                data.forEach(function (r) {
                    sums[r.dept] = (sums[r.dept] || 0) + r.salaire;
                    counts[r.dept] = (counts[r.dept] || 0) + 1;
                });
                return data.map(function (r) {
                    const avg = Math.round(sums[r.dept] / counts[r.dept]);
                    return { nom: r.nom, dept: r.dept, salaire: r.salaire, computed: avg, isNull: false };
                });
            },
            sql: "SELECT nom, dept, salaire,\n  ROUND(AVG(salaire) OVER (PARTITION BY dept)) AS moy_dept\nFROM employes;",
            explication: "<strong>AVG() OVER(PARTITION BY dept)</strong> calcule la moyenne des salaires par d&#233;partement sur chaque ligne. Pratique pour comparer le salaire individuel &#224; la moyenne de son d&#233;partement sur la m&#234;me ligne."
        },
        "COUNT_PART": {
            cols: ["nom", "dept", "salaire", "count_dept"],
            headers: ["nom", "dept", "salaire", "COUNT() par d&#233;pt"],
            compute: function () {
                const counts = {};
                data.forEach(function (r) { counts[r.dept] = (counts[r.dept] || 0) + 1; });
                return data.map(function (r) {
                    return { nom: r.nom, dept: r.dept, salaire: r.salaire, computed: counts[r.dept], isNull: false };
                });
            },
            sql: "SELECT nom, dept, salaire,\n  COUNT(*) OVER (PARTITION BY dept) AS nb_employes\nFROM employes;",
            explication: "<strong>COUNT() OVER(PARTITION BY dept)</strong> indique le nombre total d&apos;employ&#233;s dans le d&#233;partement de chaque ligne. Utile pour calculer des pourcentages&#160;: salaire / SUM(salaire) OVER(PARTITION BY dept)."
        },
        "SUM_CUMUL": {
            cols: ["nom", "mois", "salaire", "cumul"],
            headers: ["nom", "mois", "salaire", "SUM() cumulatif"],
            compute: function () {
                const sorted = data.slice().sort(function (a, b) { return a.mois - b.mois; });
                let cumul = 0;
                return sorted.map(function (r) {
                    cumul += r.salaire;
                    return { nom: r.nom, dept: r.mois, salaire: r.salaire, computed: cumul, isNull: false };
                });
            },
            sql: "SELECT nom, mois, salaire,\n  SUM(salaire) OVER (ORDER BY mois ROWS BETWEEN UNBOUNDED PRECEDING AND CURRENT ROW) AS cumul\nFROM employes;",
            explication: "<strong>SUM() cumulatif</strong> additionne les valeurs de la premi&#232;re ligne jusqu&apos;&#224; la ligne courante (ORDER BY). Chaque ligne affiche le total accumul&#233; jusqu&apos;&#224; ce point. Tr&#232;s utile pour les graphiques de progression ou totaux glissants."
        },
        "LAG": {
            cols: ["nom", "mois", "salaire", "salaire_precedent"],
            headers: ["nom", "mois", "salaire", "LAG(salaire, 1)"],
            compute: function () {
                const sorted = data.slice().sort(function (a, b) { return a.mois - b.mois; });
                return sorted.map(function (r, i) {
                    return { nom: r.nom, dept: r.mois, salaire: r.salaire, computed: i > 0 ? sorted[i - 1].salaire : null, isNull: i === 0 };
                });
            },
            sql: "SELECT nom, mois, salaire,\n  LAG(salaire, 1) OVER (ORDER BY mois) AS salaire_precedent\nFROM employes;",
            explication: "<strong>LAG(col, n)</strong> retourne la valeur de la colonne <em>n lignes avant</em> la ligne courante (dans l&apos;ordre d&#233;fini par ORDER BY). La premi&#232;re ligne retourne NULL car il n&apos;y a pas de ligne pr&#233;c&#233;dente. Pratique pour calculer des variations : salaire - LAG(salaire)."
        },
        "LEAD": {
            cols: ["nom", "mois", "salaire", "salaire_suivant"],
            headers: ["nom", "mois", "salaire", "LEAD(salaire, 1)"],
            compute: function () {
                const sorted = data.slice().sort(function (a, b) { return a.mois - b.mois; });
                return sorted.map(function (r, i) {
                    return { nom: r.nom, dept: r.mois, salaire: r.salaire, computed: i < sorted.length - 1 ? sorted[i + 1].salaire : null, isNull: i === sorted.length - 1 };
                });
            },
            sql: "SELECT nom, mois, salaire,\n  LEAD(salaire, 1) OVER (ORDER BY mois) AS salaire_suivant\nFROM employes;",
            explication: "<strong>LEAD(col, n)</strong> retourne la valeur de la colonne <em>n lignes apr&#232;s</em> la ligne courante. La derni&#232;re ligne retourne NULL. Sym&#233;trique de LAG(). Utile pour pr&#233;voir la valeur suivante ou calculer des diff&#233;rences futures."
        },
        "FIRST_VALUE": {
            cols: ["nom", "dept", "salaire", "premier_salaire"],
            headers: ["nom", "dept", "salaire", "FIRST_VALUE(salaire)"],
            compute: function () {
                const firsts = {};
                data.forEach(function (r) {
                    if (!firsts[r.dept]) firsts[r.dept] = r.salaire;
                });
                return data.map(function (r) {
                    return { nom: r.nom, dept: r.dept, salaire: r.salaire, computed: firsts[r.dept], isNull: false };
                });
            },
            sql: "SELECT nom, dept, salaire,\n  FIRST_VALUE(salaire) OVER (PARTITION BY dept ORDER BY salaire DESC) AS max_dept\nFROM employes;",
            explication: "<strong>FIRST_VALUE(col)</strong> retourne la valeur de la <em>premi&#232;re ligne</em> de la fen&#234;tre (selon ORDER BY) pour chaque ligne de la partition. Avec ORDER BY salaire DESC, cela donne le salaire le plus &#233;lev&#233; du d&#233;partement sur chaque ligne."
        },
        "LAST_VALUE": {
            cols: ["nom", "dept", "salaire", "dernier_salaire"],
            headers: ["nom", "dept", "salaire", "LAST_VALUE(salaire)"],
            compute: function () {
                const lasts = {};
                data.forEach(function (r) { lasts[r.dept] = r.salaire; });
                return data.map(function (r) {
                    return { nom: r.nom, dept: r.dept, salaire: r.salaire, computed: lasts[r.dept], isNull: false };
                });
            },
            sql: "SELECT nom, dept, salaire,\n  LAST_VALUE(salaire) OVER (\n    PARTITION BY dept ORDER BY salaire DESC\n    ROWS BETWEEN UNBOUNDED PRECEDING AND UNBOUNDED FOLLOWING\n  ) AS min_dept\nFROM employes;",
            explication: "<strong>LAST_VALUE(col)</strong> retourne la valeur de la <em>derni&#232;re ligne</em> de la fen&#234;tre. Attention&#160;: par d&#233;faut la fen&#234;tre s&apos;arr&#234;te &#224; la ligne courante. Il faut ajouter <code>ROWS BETWEEN UNBOUNDED PRECEDING AND UNBOUNDED FOLLOWING</code> pour obtenir la vraie derni&#232;re valeur de la partition."
        }
    };

    function colLabel(fn, idx) {
        const cfg = configs[fn];
        return cfg.headers[idx];
    }

    function update(fn) {
        const cfg = configs[fn];
        document.getElementById("ntileParam").style.display = fn === "NTILE" ? "flex" : "none";
        document.getElementById("sqlCode").textContent = cfg.sql;
        document.getElementById("explication").innerHTML = cfg.explication;

        const rows = cfg.compute();

        // Header
        const head = document.getElementById("resultHead");
        head.innerHTML = "<tr>" + cfg.headers.map(function (h) {
            return "<th>" + h + "</th>";
        }).join("") + "</tr>";

        // Body
        const tbody = document.getElementById("resultBody");
        tbody.innerHTML = "";

        let prevDept = null;
        rows.forEach(function (r) {
            const tr = document.createElement("tr");
            const deptChanged = r.dept !== prevDept;
            prevDept = r.dept;
            const computedCell = r.isNull
                ? "<td class=\"null-val\">NULL</td>"
                : "<td class=\"computed\">" + r.computed + "</td>";
            tr.innerHTML = "<td>" + r.nom + "</td>" +
                "<td" + (deptChanged ? " class=\"highlight\"" : "") + ">" + r.dept + "</td>" +
                "<td>" + r.salaire + "</td>" +
                computedCell;
            tbody.appendChild(tr);
        });

        document.querySelectorAll(".fn-btn[data-fn]").forEach(function (b) {
            b.classList.toggle("active", b.getAttribute("data-fn") === fn);
        });
    }

    document.querySelectorAll(".fn-btn[data-fn]").forEach(function (btn) {
        btn.addEventListener("click", function () { update(btn.getAttribute("data-fn")); });
    });
    document.getElementById("ntileApply").addEventListener("click", () => update("NTILE"));
    update("ROW_NUMBER");
})();